<script setup lang="ts">
const init3 = useInited('init3')
const auth = updateUserDoc()
const initNotifivations = computed((): boolean => init3.value && auth.user.value.isAuth && auth.user.value.buyerNotifications === true)
</script>

<template>
  <div :class="$style.cart" class="_relative _row _ctrY">
    <IconBell class="_svg22" />
    <LazyAppNotificationsCount v-if="initNotifivations" :class="$style.size" />
    <LazyNotificationsInit v-if="initNotifivations" />
  </div>
</template>

<style module>
.cart {
  color: currentColor;
  cursor: pointer;
  margin: 0;
}

:global(.CartIcon) .cart::before {
  content: '';
  display: block;
  top: -6px;
  left: 0px;
  height: 44px;
  width: 44px;
  position: absolute;
  border-radius: 50%;
  z-index: -1;
  background: var(--black-5);
  opacity: 0.01;
  transform: scale(1.05);
}
ƒ :global(.CartIconActive) .cart::before {
  opacity: 0.99;
}

.size {
  composes: global(_absolute);
  composes: global(_fs1);
  composes: global(_fw-l);
  composes: global(_h14);
  composes: global(_br99);
  composes: global(_ctr);
  composes: global(_ls-xs);

  composes: global(_mta);
  composes: global(_mba);
  composes: global(_mla);
  composes: global(_mra);

  composes: global(_c0);
  min-width: 14px;
  background: var(--blue3);
  line-height: 11px;
  right: -3px;
  top: -1px;
  padding: 1px 2px 0 3px;
}
</style>
